import React from 'react';
import { DecisionTableRow } from '../types';
import { formatSafeCurrency, formatDelta, getTrend } from '../utils';

export interface DecisionTableProps {
  rows: DecisionTableRow[];
  className?: string;
}

export const DecisionTable: React.FC<DecisionTableProps> = ({ rows, className = '' }) => {
  return (
    <div className={`decision-table ${className}`}>
      <table>
        <thead>
          <tr>
            <th>Option</th>
            <th>Lifespan</th>
            <th>Replacements</th>
            <th>Annual Cost</th>
            <th>Total Cost</th>
            <th>Delta vs Baseline</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => {
            const trend = getTrend(row.deltaVsBaseline_gbp);
            const trendClass = trend === 'negative' ? 'positive-delta' : trend === 'positive' ? 'negative-delta' : 'neutral-delta';
            
            return (
              <tr key={index} className={row.isBaseline ? 'baseline-row' : ''}>
                <td className="option-name">
                  {row.optionName}
                  {row.isBaseline && <span className="baseline-badge"> (Baseline)</span>}
                </td>
                <td>{row.lifespan}</td>
                <td>{row.replacements}</td>
                <td>{formatSafeCurrency(row.annualCost_gbp)}</td>
                <td>{formatSafeCurrency(row.totalCost_gbp)}</td>
                <td className={trendClass}>
                  {row.isBaseline ? '—' : formatDelta(row.deltaVsBaseline_gbp)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
